import { useState } from "react";
import toast from "react-hot-toast";
import {
  createCityPageForCity
} from "../../services/CityPages.service";
import AutoSuggest from "../shared/AutoSuggest";
import Button from "../ui/Button";
import Modal from "../ui/Modal";

interface CreateCityPageModalProps {
  show: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const CreateCityPageModal: React.FC<CreateCityPageModalProps> = ({
  show,
  onClose,
  onSuccess
}) => {
  const [selectedCityId, setSelectedCityId] = useState<string>("");

  const handleCreate = async () => {
    const cityIdNumber = Number(selectedCityId);

    if (!selectedCityId || Number.isNaN(cityIdNumber) || cityIdNumber <= 0) {
      toast.error("Ju lutem zgjidhni një qytet nga autocomplete.");
      return;
    }

    try {
      await createCityPageForCity(cityIdNumber);
      toast.success("Gjenerimi i faqes së qytetit u nis me sukses.");
      onSuccess();
      onClose();
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        "Ndodhi një gabim gjatë gjenerimit të faqes së qytetit.";
      toast.error(message);
    }
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      title="Krijo faqe të re qyteti"
      position="center"
      modalWidth="500px"
    >
      <div className="flex h-full min-h-[260px] flex-col p-4">
        <div className="flex flex-col gap-4 flex-1">
          <p className="text-sm text-gray-600">
            Kërko destinacionin (qytetin / location) që dëshiron ta gjenerosh si
            faqe qyteti.
          </p>
          <div>
            <label className="mb-1 block text-sm font-semibold text-gray-700">
              Qyteti / Destinacioni
            </label>
            <AutoSuggest
              placeholder="Kërko qytetin sipas emrit..."
              onChange={(id) => setSelectedCityId(id)}
            />
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-4 mt-auto">
          <Button
            type="button"
            onClick={onClose}
            className="bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Anulo
          </Button>
          <Button type="button" onClick={handleCreate}>
            Gjenero faqen e qytetit
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateCityPageModal;
